import { useEffect, useState } from 'react';
import { api } from '@/shared/api/axios';

const BASE = '/api/biometric/v2';

/** The capture a device took at a punch. The image is private, so it is fetched with the login and shown from memory. */
export function PunchPhoto({ path }: { path: string }) {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    let url: string | null = null;
    let cancelled = false;
    api
      .get(`${BASE}/${path}`, { responseType: 'blob' })
      .then((res) => {
        if (cancelled) return;
        url = URL.createObjectURL(res.data as Blob);
        setSrc(url);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [path]);

  if (!src) return <span className="inline-block h-8 w-8 rounded bg-surface-variant" aria-hidden />;
  return (
    <a href={src} target="_blank" rel="noreferrer">
      <img src={src} alt="Attendance capture" className="h-8 w-8 rounded object-cover" />
    </a>
  );
}
